export default {
  title: "Hitamo Itsinda ryo Kwizigamira",
  subtitle: "Hitamo itsinda ushaka gukoreramo.",
  loading: "Amatsinda yawe arimo gutegurwa...",
  emptyTitle: "Nta tsinda rikora ryabonetse",
  emptyMessage: "Nta tsinda rikora washyizwemo.",
  role: "Inshingano",
  select: "Hitamo",
  pleaseWait: "Tegereza...",
  logout: "Sohoka",
  help: "Ururimi wahisemo ruzakomeza gukoreshwa muri sisitemu yose.",
  roles: {
    owner: "Nyir’Itsinda",
    admin: "Umuyobozi",
    treasurer: "Umubitsi",
    member: "Umunyamuryango",
  },
  errors: {
    tooManyAttempts:
      "Wagerageje inshuro nyinshi. Tegereza umunota umwe wongere ugerageze.",
    loadFailed: "Gufungura amatsinda yawe byanze.",
    selectFailed:
      "Guhitamo itsinda byanze. Ongera ugerageze.",
  },
};
